import { axiosWithAuth } from "helpers";

export const boardingACHProcessor = {
	getACHProcessorData,
	updateACHProcessorData,
};

const API_URL = process.env.REACT_APP_API_URL;

function getACHProcessorData(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/ach`,
	};

	return axiosWithAuth(options);
}

function updateACHProcessorData({
	applicationId,
	fieldData,
}: {
	applicationId: string;
	fieldData: {
		fieldBeName: string;
		fieldValue: string | number;
	};
}) {
	const options = {
		method: "PATCH",
		data: [
			{
				value: fieldData.fieldValue,
				path: `/${fieldData.fieldBeName}`,
				op: "replace",
			},
		],
		url: `${API_URL}/api/applications/${applicationId}/ach`,
		headers: { "Content-Type": "application/json-patch+json" },
	};

	return axiosWithAuth(options);
}
